<template>
    <div>
        <div>
            <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" class="mb10" :confKey="confKey" :queryOnLoad="queryOnLoad" :configAuto="true" :queryHandler="queryHandler"></swb-query-sort-area>
            <swb-result-table name="result_table" ref="result_table" :confKey="resultKey" :configAuto="true" :needPager="needPager" :height="tableHeight" :rowNoShow="rowNoShow" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
        </div>
    </div>

</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'


    import shopStuffApi from '../../api/shopStuff'

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-shop-stuff-act-rec-list',
        props: ['stuffId', 'srcVoucherType', 'srcVoucherNo', 'showComFlag','hiddenActSearch'],
        data: function () {
            return {
                confKey: "swb-shop-device-act-rec-list-2",
                resultKey: "swb-shop-device-act-rec-list-2",
                queryOnLoad: true,

                tableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                resultColConf: null,
                rowNoShow: false,
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                shopDeviceRecList: [],

                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            if(this.showComFlag) {
                this.resultKey = "swb-shop-stuff-act-rec-list-2";
            } else {
                this.resultKey = "swb-shop-stuff-act-rec-list-1";
            }
            if(Utils.isNoB(this.srcVoucherType)) {
                this.confKey = "swb-shop-stuff-act-rec-list-2";
            } else {
                this.confKey = "swb-shop-stuff-act-rec-list-1";
            }
            if(!Utils.isNoB(this.hiddenActSearch) && this.hiddenActSearch) {
                this.confKey = "swb-shop-stuff-act-rec-list-1";
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            //domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), null);
            //domSizeWatcher.setHrEls();

            //domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去
                resultTable.setQrySortRef(query_model_ctrl);
                // resultTable.setColConfRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'actDepartName': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null) {
                            return '<span>' + colValue + '</span>';
                        } else {
                            return '<span>无</span>';
                        }
                    }
                }, /* 单元格按钮点击处理函数 */{});
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getStuffRecList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getStuffRecList();
            },
            getStuffRecList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(self.stuffId)) {
                    filterItems.stuffId = self.stuffId;
                }
                if(!Utils.isNoB(self.srcVoucherType)) {
                    filterItems.srcVoucherType = self.srcVoucherType;
                }
                if(!Utils.isNoB(self.srcVoucherNo)) {
                    filterItems.srcVoucherNo = self.srcVoucherNo;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let msgBoxDlg = MsgBox.loading();
                shopStuffApi.getShopStuffRecList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.shopStuffRecList = result.data.rows;
                        let pagination = result.data.pagination;
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(result.data.rows, pagination);
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            queryEventHanlder: function (postData) {
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getStuffRecList();
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/shopStuff/ShopStuffRecList.vue